import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.reducer';
import * as AuthActions from 'app/store/actions/auth.actions';
import { UsuarioAutenticado } from "../models/signIn.model";


@Injectable({
  providedIn: 'root'
})
export class PersistanceService {

  constructor(
    private store: Store<AppState>
  ) { }

  setSession(key: string, data: any) {
    try {
      localStorage.setItem(key, data);
    } catch (e) {
      console.log('Error en storage: ', e);
    }
  }

  getSession(key: string) {

    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.log('Error en storage: ', e);
      return;
    }
  }

  setUser(usuarioAutenticado: UsuarioAutenticado) {
    localStorage.setItem('user', JSON.stringify(usuarioAutenticado));
  }

  getUser(): any {
    let userResponse: any;
    let user = localStorage.getItem('user');
    if (user != null) {
      userResponse = JSON.parse(user);
    }
    return userResponse;
  }

  removeUser() {
    console.log("Removiendols de user")
    localStorage.removeItem('user');
    sessionStorage.clear();
  }


  //hidratate store (call app.component)
  hidratateStore() {
    //currentUser data persist (RESTAURANT-PROVIDER)
    if (this.getSession('user')) {
      this.store.dispatch(new AuthActions.SetAuthenticated(
        this.getUser()
      ));
    }

  }

  //clean session storage
  remove_localStorage() {
    this.removeUser();
  }
}
